import '../styles/Benefits.css';
import { useBenefitsImagesForHome } from '../context/HomeConfigContext.jsx';

const BENEFITS = [
  { icon: 'payments', title: 'Pagos semanales y altos porcentajes', text: '50%, 60%, 70% y hasta el 80% de ventas generadas.' },
  { icon: 'photo_camera', title: 'Fotografía profesional y perfiles', text: 'Diseño de perfiles de alta calidad para destacar tu imagen.' },
  { icon: 'school', title: 'Capacitación y monitoreo 24/7', text: 'Entrenamiento constante además de monitoreo las 24 horas.' },
  { icon: 'devices', title: 'Soporte técnico y tecnología', text: 'Tecnología de alto nivel para tus mejores transmisiones.' },
  { icon: 'apartment', title: 'Instalaciones de alto impacto', text: 'Espacios hechos a la medida para tener tus mejores transmisiones.' },
];

function Benefits() {
  const galleryImgs = useBenefitsImagesForHome();
  const imgs = galleryImgs.length >= 4 ? galleryImgs : [null, null, null, null];
  return (
    <section id="beneficios" className="tm-section tm-benefits-section">
      <div className="tm-container">
        <div className="tm-benefits-grid">
          <div className="tm-benefits-content">
            <div className="tm-benefits-number">01</div>
            <div className="tm-benefits-header">
              <h3 className="tm-benefits-subtitle">¿Qué ofrecemos?</h3>
              <h2 className="tm-benefits-title">
                Servicios
                <span className="tm-benefits-title-italic">Exclusivos</span>
              </h2>
            </div>
            <p className="tm-benefits-intro">
              TMSTUDIO es conocido por desarrollar exitosas carreras como modelo Webcam en lugar de ofrecerte un trabajo común. Esta es la oportunidad y decisión que cambiará tu vida, sacándote de tu zona de confort y llevándote a otro nivel. Nos enfocamos en mejorar el estilo de vida de nuestros modelos, permitiéndoles alcanzar sueños nunca antes pensados.
            </p>
            <div className="tm-benefits-cards">
              {BENEFITS.map(({ icon, title, text }) => (
                <div key={title} className="tm-benefits-card">
                  <div className="tm-benefits-icon">
                    <span className="material-symbols-outlined tm-benefits-icon-symbol">{icon}</span>
                  </div>
                  <h4 className="tm-benefits-card-title">{title}</h4>
                  <p className="tm-benefits-card-text">{text}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="tm-benefits-gallery">
            <div className="tm-benefits-item">
              {imgs[0] && <div className="tm-benefits-img-wrap"><img src={imgs[0]} alt="" className="tm-benefits-img tm-benefits-img-dark" /></div>}
              {imgs[1] && <div className="tm-benefits-img-wrap"><img src={imgs[1]} alt="" className="tm-benefits-img" /></div>}
            </div>
            <div className="tm-benefits-item tm-benefits-item-padded">
              {imgs[2] && <div className="tm-benefits-img-wrap"><img src={imgs[2]} alt="" className="tm-benefits-img" /></div>}
              {imgs[3] && <div className="tm-benefits-img-wrap"><img src={imgs[3]} alt="" className="tm-benefits-img tm-benefits-img-light tm-benefits-img-border" /></div>}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Benefits;

